import { getOffersUrl } from './helpers';
import { getConfig } from '../../../app/src/services/config';

const { webHost } = getConfig();

export const httpGet = (url) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const options = {
    method: 'GET',
    headers,
  };
  const request = new Request(`${window.location.protocol}//xpart.in.ua/${url}`, options);
  return fetch(request).then((res) => res.json());
};

export const httpPost = (url, data = {}) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const options = {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  };

  return fetch(`${window.location.protocol}//xpart.in.ua/${url}`, options).then((res) =>
    res ? res.json() : {},
  );
};

export const parserGet = (url = `${window.location.protocol}//xpart.in.ua/allegro`, data = {}) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const options = {
    method: 'GET',
    headers,
  };
  return fetch(getOffersUrl(data) || url, options).then((res) => res.json());
};

export const parserGetCategory = async (data = {}) => {
  try {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    };

    const res = await fetch(`${window.location.protocol}//xpart.in.ua/scraper/category`, options);
    return await res.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const parserGetProduct = async (data = {}) => {
  try {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    };

    const res = await fetch(`${window.location.protocol}//xpart.in.ua/scraper/product`, options);
    return await res.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const parserSearch = async (data = {}) => {
  try {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    };

    const res = await fetch(`${window.location.protocol}//xpart.in.ua/scraper/search`, options);
    return await res.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};
